import { extended, http } from '@jota-one/http-client'
import { isEmpty, get } from 'lodash'
import { hasAuthTokenCb, getAuthToken } from '@/helpers/authToken'

let $clients = {}

const factory = {
  create ({ axiosConfig, name = 'default', overwrite = false }) {
    if (overwrite || $clients[name] === undefined) {
      $clients[name] = http({
        withCredentials: true,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        ...axiosConfig
      })
    }

    return $clients[name]
  },

  createHateoas ({
    axiosConfig,
    rootEndpoint,
    name = 'default',
    overwrite = false,
    headersMap = {
      headers: {},
      source: {}
    }
  }) {
    if (overwrite || $clients[name] === undefined) {
      let headers = {
        'X-Requested-With': 'XMLHttpRequest'
      }
      if (!isEmpty(headersMap.headers)) {
        headers = Object.entries(headersMap.headers).reduce((acc, [headerName, path]) => {
          const headerValue = get(headersMap.source, path)
          if (headerValue) {
            acc[headerName] = headerValue
          }
          return acc
        }, headers)
      }
      $clients[name] = extended({
        cacheStrategy: 'rootIndexOnly',
        enableLogging: process.env.NODE_ENV === 'development',
        axiosConfig: {
          withCredentials: true,
          headers,
          ...axiosConfig
        },
        axiosConfigCb: async () => {
          if (!process.env.VUE_APP_JWT_ACTIVE) {
            return {}
          }

          if (hasAuthTokenCb()) {
            const token = await getAuthToken()

            if (token) {
              return {
                headers: {
                  authorization: `Bearer ${token}`,
                },
              }
            }
            return {}
          } else {
            console.warn('no jwt token callback found (http)')
          }

          return {}
        },
        rootEndpoint,
        rootIndexLinksPath: 'data'
      })
    }

    return $clients[name]
  }
}

export const client = (name = 'default') => {
  return $clients[name]
}

export default factory
